import React, {
  useState,
  useEffect,
  createContext,
  SetStateAction,
} from "react";
import { getUserInfo } from "../api/userApi";

export type UserData = {
  name: string;
  authenticated: boolean;
};

type UserContextType = {
  user: UserData | null;
  setUser: React.Dispatch<React.SetStateAction<UserData | null>>;
  isLoaded: boolean;
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>;
};

type UserContextProviderProps = {
  children: React.ReactNode;
};

export const UserContext = createContext({
  isLoaded: false,
} as UserContextType);

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
  const [user, setUser] = useState<UserData | null>(null);
  const [isLoaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!isLoaded) {
      getUserInfo(
        (responseData: SetStateAction<any>) => {
          setUser({
            name: responseData.name,
            authenticated: responseData.authenticated,
          });
          setLoaded(true);
        },
        () => {}
      );
    }
  });

  return (
    <UserContext.Provider value={{ user, setUser, isLoaded, setLoaded }}>
      {children}
    </UserContext.Provider>
  );
};
